<div class="container">
    <div style="text-align: center;">
        <span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true" *ngIf="datausuario==null"></span>
    </div>
    

    <div class="card shadow-lg border-0 rounded-lg mt-5" *ngIf="datausuario!=null">
        <div class="card-header" style="color: teal;">
            <h3 class="text-center font-weight-light my-4">{{datausuario.data().nombre}}</h3>
            <p>Id: {{datausuario.data().cedula}}</p>
        </div>
        <div class="card-body">

            <ul class="list-group">
                <li class="list-group-item"><strong>Email: </strong>{{datausuario.data().email}}</li>
                <li class="list-group-item"><strong>Cel: </strong>{{datausuario.data().celular}}</li>
                <li class="list-group-item"><strong>Localidad: </strong>{{datausuario.data().localidad}}</li>
                <li class="list-group-item"><strong>Barrio: </strong>{{datausuario.data().barrio}}</li>
                <li class="list-group-item"><strong>Dirección: </strong>{{datausuario.data().direccion}}</li>
                <li class="list-group-item list-group-item-primary"><strong>Contacto emergencia: </strong>{{datausuario.data().contactoEmergencia}}</li> 
                <li class="list-group-item list-group-item-primary"><strong>Teléfono emergencia: </strong>{{datausuario.data().telefonoEmergencia}}</li> 
              </ul>

              <ul class="list-group">
                <li class="list-group-item"><strong>Actividad Física: </strong>{{datausuario.data().actividadFisica}}</li>
                <li class="list-group-item"><strong>Lugar: </strong>{{datausuario.data().lugarActividadFisica}}</li>
                <li class="list-group-item"><strong>Va a supermercado: </strong>{{datausuario.data().irASupermercado}}</li>
                <li class="list-group-item"><strong>Frecuencia: </strong>{{datausuario.data().frecuenciaIrASupermercado}}</li>
                <li class="list-group-item"><strong>Visita amigos: </strong>{{datausuario.data().visitaAmigos}}</li>
                <li class="list-group-item"><strong>Frecuencia: </strong>{{datausuario.data().frecuenciaVisitasAmigos}}</li> 
                <li class="list-group-item"><strong>Permanece en casa: </strong>{{datausuario.data().permaneceEnCasa}}</li> 
                <li class="list-group-item"><strong>Razón salida: </strong>{{datausuario.data().razonSalidaCasa}}</li> 
                <li class="list-group-item"><strong>Otras actividades: </strong>{{datausuario.data().otrasActividades}}</li> 
                <li class="list-group-item"><strong>Descripción: </strong>{{datausuario.data().descOtrasActividades}}</li> 
              </ul>
           
        </div>
        <div class="card-footer text-center">
           <button class="btn btn-danger  btn-block" (click)="cerrar()">Cerrar</button>
        </div>
    </div>
</div>